import './App.css';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import Vision from './components/vision.js';
import Events from './components/events.js';
import Interviews from './components/interviews.js';
import Contact from './components/contact.js';
import Footer from './components/footer.js';
import Partners from './components/partners.js';
import IntroView from './components/introView.js';
import FloatingCursor from './components/FloatingCursor';
import AllEvents from './components/AllEvents';

/* スクロール制御付きトップページ */
function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // 遅延させると描画後でも確実にスクロールされる
      setTimeout(() => {
        const target = document.querySelector(location.hash);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location]);

  return (
    <div className="App">
      <FloatingCursor />
      <IntroView />
      <Vision />
      <Events />
      <Interviews />
      <Partners />
      <Contact />
      <Footer />
    </div>
  );
}

/* アプリ全体のルーティング */
function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/allevents" element={<AllEvents category="event" />} />
      <Route path="/allevents/:eventId" element={<AllEvents category="event" />} />
      <Route path="/interviews" element={<AllEvents category="interview" />} />
      <Route path="/interviews/:eventId" element={<AllEvents category="interview" />} />
    </Routes>
  );
}

export default App;
